import styled from 'styled-components';
import { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';

export const MapMarkerContainer = styled.div.attrs({
  'data-test-id': 'map-dealer-container',
})<Coordinates>`
  position: absolute;
`;
